import React from 'react'
import Header from '../../components/header'
import { Settings, User } from 'lucide-react';
import { useNavigate } from 'react-router-dom';


const Admin = () => {
  const navigate = useNavigate();
  return (
    <div className='h-screen flex flex-col dark:bg-gray-900'>
      <Header/>
      <div className="flex flex-col items-center mt-10 flex-1">
        <div className='border shadow-md rounded-xl p-10 w-full max-w-7xl flex flex-col items-center gap-6 bg-white dark:bg-gray-800 dark:border-gray-700'>
            {/* Icon Circle */}
            <div className="mx-auto h-24 w-24 bg-gray-100 dark:bg-gray-700 rounded-full flex items-center justify-center mb-4">
              <Settings size={48} className="text-gray-500 dark:text-gray-400" />
            </div>  

            {/* Title & Subtitle */}
            <h2 className="text-lg font-semibold text-gray-800 dark:text-white mb-2">
              Configuration Management
            </h2>
            <p className="text-gray-500 dark:text-gray-400 mb-6">
              Select a configuration option from the buttons above to get started
            </p>

            {/* Buttons */}
            <div className="flex gap-4">
              <button className="btn btn-secondary flex items-center gap-2 rounded-full dark:hover:bg-blue-600" onClick={() => navigate('/admin/master-configuration')}>
                <Settings size={16} /> Master Configuration
              </button>
              <button className="btn btn-outline flex items-center gap-2 rounded-full dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-700"
                onClick={() => navigate('/admin/user-configuration')}  
              >
                <User size={16} /> User-wise Configuration
              </button>
            </div>
        </div>
      </div>
    </div>
  )
}

export default Admin